import Reveal from "@/components/Reveal";
import { PROCESS } from "@/data/site";

export default function ProcessTimeline() {
  return (
    <section
      className="relative py-24 md:py-32 ink-grain"
      data-testid="process-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 lg:sticky lg:top-32 lg:h-fit">
            <Reveal>
              <span className="eyebrow">How we work</span>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-6xl mt-5">
                Sprint. <br />
                Ship. <br />
                <span className="text-[#FF4500]">Compound.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="text-white/70 mt-6 max-w-md">
                Four phases. Weekly increments. Zero waterfall theatre. You see
                progress every Friday or it didn't happen.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 relative">
            <div
              aria-hidden
              className="absolute left-[34px] top-2 bottom-2 w-px bg-gradient-to-b from-[#FF4500]/60 via-white/15 to-transparent"
            />
            <ul className="space-y-10">
              {PROCESS.map((p, i) => (
                <Reveal as="li" key={p.step} delay={i * 0.08} className="relative pl-24">
                  <span className="absolute left-0 top-0 inline-flex h-[68px] w-[68px] items-center justify-center rounded-full border border-[#FF4500]/40 bg-[#0F0F0F] font-mono text-sm text-[#FF4500] shadow-[0_0_30px_-5px_rgba(255,69,0,0.5)]">
                    {p.step}
                  </span>
                  <h3 className="font-display text-3xl md:text-4xl font-bold uppercase tracking-tight leading-none">
                    {p.title}
                  </h3>
                  <p className="text-white/75 mt-3 max-w-xl">{p.body}</p>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
